module.exports = __webpack_public_path__ + "img/advancing-market__photo.dfd18f46.jpg";